module.exports = __webpack_public_path__ + "assets/font/SourceHanSansKR-Normal-05522dd9.otf";